<template>
  <footer class="footer">
    <div class="company-copyright">
      <div class="logo_second">
        <img src="https://static.gabia.com/fonts/project/image/logo2.svg" alt="gabia logo">
      </div>
      <div class="copyright">
        <i class="far fa-copyright"></i> 2022 Gabia Inc. All Rights Reserved.
      </div>
    </div>
    <div class="foot-menu-share">
      <div class="company-link">
        <a href="https://www.gabia.com/" target="_blank">가비아</a>
        <a href="https://company.gabia.com/" target="_blank">회사소개</a>
      </div>
      <div class="share-sns-list">
        <div class="sns-title">가비아 글꼴 공유</div>
        <div class="share-sns" v-for="sns in shareSns" :key="sns.name" @click="sharedSns(sns.name)" :id="sns.name">
          <img :src="`https://static.gabia.com/fonts/project/image/share_sns/share_${sns.name}.svg`" alt="sns.name" >
        </div>
      </div>
    </div>
  </footer>
</template>

<script>

export default {
  name: 'Footer',
  data() {
    return {
      shareSns: [
        { name: 'kakao', connect_link: '' },
        { name: 'facebook', connect_link: '' },
        { name: 'twitter', connect_link: '' },
        { name: 'link', connect_link: '' },
      ],
      shareInfo: {
        title: '가비아 글꼴 프로젝트',
        url: 'https://font.gabia.com',
      },
    };
  },
  methods: {
    sharedSns(sns) {
      if (sns === 'twitter') this.shareTwitter();
      if (sns === 'facebook') this.shareFacebook();
      if (sns === 'kakao') this.shareKakao();
      if (sns === 'link') {
        const contents = 'https://font.gabia.com';
        navigator.clipboard.writeText(contents);
      }
    },
    shareTwitter() {
      window.open(`https://twitter.com/intent/tweet?text=${this.shareInfo.title}&url=${this.shareInfo.url}`);
    },
    shareFacebook() {
      window.open(`http://www.facebook.com/sharer/sharer.php?u=${this.shareInfo.url}`);
    },
    shareKakao() {
      // 카카오링크 버튼 생성
      this.$kakao.Link.createDefaultButton({
        container: '#kakao', // 카카오공유버튼ID
        objectType: 'feed',
        content: {
          title: this.shareInfo.title, // 보여질 제목
          description: '', // 보여질 설명
          imageUrl: this.shareInfo.url, // 콘텐츠 URL
          link: {
            mobileWebUrl: this.shareInfo.url,
            webUrl: this.shareInfo.url,
          },
        },
      });
    },

  },
};
</script>

<style lang="scss" scoped>
footer {
  height: 233px;
  border-top: 1px solid #AAAAAA;
  padding: 60px;
  display: flex;
  justify-content: space-between;
  .company-copyright {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .logo_second {
      width: 80px;
    }
    .copyright {
      font-size: 18px;
      color: #AAA;
      i {
        font-size: 0.9em;
      }

    }
  }
  .foot-menu-share {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .company-link {
      display: flex;
      justify-content: flex-end;
      font-size: 18px;
      a {
        line-height: 1;
        color: #AAAAAA;
        font-weight: 500;
        padding: 0 10px;
        &:first-child {
          border-right: 1px solid #AAAAAA;
        }
      }
    }
    .share-sns-list {
      display: flex;
      justify-content: flex-end;
      line-height: 1;
      .share-sns {
        cursor: pointer;
        margin: 0 5px;
      }
      .sns-title {
        font-weight: 500;
        font-size: 16px;
        color: #AAAAAA;
        padding: 10px;
      }
    }
  }
}
</style>
